<template lang="pug">
v-dialog(
    v-model="show",
    width="auto",
    max-width="700px",
    persistent, v-if="categoria")
    form(
        @submit.prevent="validate()",
        data-vv-name="categoria",
        style="width: 100%"
    )
        v-card(style="border-radius: 10px;")
            v-card-title
                span.title Cadastrar Categoria de Variação
            v-card-text
                v-layout.px-2.pb-0.mb-0(row, wrap)
                    v-flex.xs12.pb-0.mb-0
                        v-text-field.pb-0.mb-0.inputDefault(
                            color="gray",
                            label="Nome",
                            required,
                            v-validate="'required'",
                            :error-messages="errors.collect('nome')",
                            data-vv-name="nome",
                            type="text",
                            v-model="categoria.nome",
                            autofocus,
                            :hide-details="false"
                            outline
                        )
                v-layout.pa-2(row, wrap)
                    v-flex.xs12
                        v-select.inputDefault(
                        color="gray",
                        label="Cálculo do preco",
                        item-text="nome",
                        item-value="id",
                        :items="mod_preco",
                        required,
                        v-validate="'required'",
                        :error-messages="errors.collect('mod')",
                        data-vv-name="mod",
                        data-vv-as="cálculo do preço",
                        type="text",
                        v-model="categoria.mod_preco",
                        @change="changeModPreco(categoria)",
                        :hide-details="true"
                        outline
                        )
                v-layout.pa-2(row, wrap)
                    v-flex.xs6
                        v-text-field.pt-2.inputDefault(
                            color="gray",
                            label="Qtd min.",
                            :disabled="categoria.mod_preco == 2",
                            required,
                            v-validate="`required|max_value:${categoria.max}`",
                            :error-messages="errors.collect('min')",
                            data-vv-name="min",
                            data-vv-as="quantidade mínima",
                            type="number",
                            v-model="categoria.min",
                            :hide-details="true"
                            outline
                        )
                    v-flex.xs6.pl-1
                        v-text-field.pt-2.inputDefault(
                            color="gray",
                            label="Qtd max.",
                            :disabled="categoria.mod_preco == 2",
                            required,
                            v-validate="'required|min_value:1'",
                            :error-messages="errors.collect('max')",
                            data-vv-name="max",
                            data-vv-as="quantidade máxima",
                            type="number",
                            v-model="categoria.max",
                            :hide-details="true"
                            outline
                        )
                    v-flex.md6.xs12.pl-1(v-if="categoria.mod_preco == 1 && categoria.max > 1")
                        v-checkbox(
                            color="primary",
                            label="Permitir escolha de itens repetidos",
                            v-model="categoria.repetir_itens",
                            :true-value="1",
                            :false-value="0"
                        )
                    v-flex.md12.xs12.pt-0(v-bind:class="[$root.mobile ? 'areaAbtnsComplementos' : '']")
                        v-card-actions.right(v-if="($root.user.permissao_cardapio)")
                            v-spacer(v-if="!$root.mobile")
                            v-btn.btnSalvar(
                                depressed,
                                color="primary",
                                type="submit",
                                :loading="loading",
                                :disabled="loading"
                                ) Salvar
                        v-btn.right(
                            type="button",
                            flat,
                            color="gray darken-1",
                            @click.native="show = false; categoria = null"
                        ) Fechar
    </template>

<script>

export default {
    $_veeValidate: {
        validator: "new",
    },
    data: () => ({
        show: false,
        loading: false,
        categoria: null,
        categorias: null,
        item: null,
        CONST_MOD_PRECO: {
            AIDICONA: 1,
            SUBSTITUI: 2,
            SUBSTITUI_MEDIA: 3,
            SUBSTITUI_MAIOR: 4,
        },
        mod_preco: [
            { id: 1, nome: "Adiciona ao valor do item" },
            { id: 2, nome: "Substitui o valor do item pelo valor do complemento" },
            {
                id: 3,
                nome: "Substitui o valor do item pela média dos valores dos complementos",
            },
            {
                id: 4,
                nome: "Substitui o valor do item pelo complemento de maior valor",
            },
        ]
    }),
    mounted() { },
    watch: {},
    methods: {
        open(categoria, item, categorias) {
            this.show = true;
            this.item = item;
            this.categorias = categorias;

            this.categoria = categoria ? _.cloneDeep(categoria) : {
                indice: -1,
                ativo: 1,
                min: 0,
                max: 1,
                mod_preco: 1,
                variacao: 1,
                versao: 0,
                catalogo_id: item.catalogo_id,
                turno1: 1,
                turno2: 1,
                itens_repetidos: 1,
            };
        },
        changeModPreco(categoria) {
            if (categoria.mod_preco == 2) categoria.max = 1;
            categoria.min = categoria.mod_preco == 1 ? 0 : 1;
        },
        async validate() {
            try {
                this.loading = true;

                const result = await this.$validator.validateAll('categoria');

                if (!result) throw "Preencha todos os campos corretamente!";

                else if (parseFloat(this.categoria.min) < 0) {
                  throw "A quantidade mínima não pode ser negativa.";
                }
                else if (parseFloat(this.categoria.max) < 0) {
                  throw "A quantidade máxima não pode ser negativa.";
                }
                else if (parseFloat(this.categoria.min) > parseFloat(this.categoria.max)) {
                  throw "A quantidade mínima não pode ser maior que a máxima";
                }
                else if (!this.categoria.nome) {
                  throw "Informe o nome da variação.";
                }
                if (this.categoria && this.categoria.nome && this.categoria.nome.length > 100) {
                  this.$validator.errors.add({
                    field: 'nome',
                        msg: 'O nome da categoria deve ter menos de 100 caracteres!'
                    });
                  this.loading = false;""
                  return false;
                }

                this.save(this.categoria);

                this.loading = false;
                this.show = false;
            } catch (error) {
                window.getApp.$emit("APP_ALERT", { color: "red", text: error });
                this.loading = false;
            }
        },
        async save(categoria) {
            try {

                if(this.item && this.item.variacoes && this.item.variacoes.length) categoria.indice = this.item.variacoes.length
                const responseCategoria = await this.$axios[categoria.id ? 'put' : 'post']("/catalogo/categoria", categoria);

                if (!categoria.id) {

                    categoria = _.merge(categoria, responseCategoria.data);

                    categoria.allItens = [];
                    categoria.itens_vinculados = [];

                    const responseVariacao = await this.$axios.post("/catalogo/variacao", {
                        categoria_id: categoria.id,
                        item_catalogo_id: this.item.id
                    });

                    categoria.variacao_id = responseVariacao.data.id;
                }

                this.$emit('refresh-variacoes', categoria);

                this.loading = false;
                this.$validator.reset();
                window.getApp.$emit("APP_ALERT", {
                    color: "success",
                    text: "Categoria salva com sucesso!",
                });

            } catch (error) {
                console.log(error);
                let err =
                    error.response && error.response.data
                        ? error.response.data.error
                        : "Ocorreu um erro ao salvar a categoria. Tente novamente!";
                window.getApp.$emit("APP_ALERT", { color: "red", text: err });
                this.loading = false;
            }
        }
    },
};
</script>

<style lang="scss">
.inputDefault .v-input__control .v-input__slot{
    background-color: #f6f6f6!important;
    border-radius: 10px;
    border: 1px solid rgba(0, 0, 0, .15)!important;
}

.inputDefault.v-input.v-input--is-focused .v-input__control .v-input__slot{
    border: 1px solid #1d9a5a !important;
}
</style>
<style scoped>
.areaAbtnsComplementos{
    padding: 0 !important;
    justify-content: flex-start;
    display: flex;
    flex-flow:column wrap;
    align-content: stretch;
    align-items: stretch;
}
.btnSalvar{
    width: 100%;
    border-radius: 5px !important;
    color:#fff;
    font-weight: 600;
}
</style>
